module.exports = __webpack_public_path__ + "static/media/play.6ab41a46.svg";